import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ButtonModule} from '../button/button.module';
import {ExpandableContentComponent} from './expandable-content.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
    ],
    declarations: [
        ExpandableContentComponent,
    ],
    exports: [ExpandableContentComponent]
})
export class ExpandableContentModule {}
